import { importComponent } from '@xingternal/hops';

export default importComponent(() => import('react-player'));
